export default __webpack_public_path__ + "static/image164-2b7c75da4c688e0a44227e2d73e390d0.jpg";